var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"扫码投屏","visible":_vm.dialogVisible,"append-to-body":true,"close-on-click-modal":false,"width":"450px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[[_c('div',[_vm._v(" 模块正在开发中，敬请期待 ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }